// ===================================================================
// THIS FILE WAS AUTO GENERATED DO NOT EDIT IMPLACE
// ===================================================================
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

/**
 * File entry types
 */
export enum ECpmCFileEntryTypeApiEnum {
    NOT_SET = 'NOT_SET',
    USER = 'USER',
    ENTITY = 'ENTITY'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCFileEntryTypeApiEnum = Object.fromEntries(
    Object.entries(ECpmCFileEntryTypeApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCFileEntryTypeApiEnum
        ])
);

